import React from 'react';
import { Header } from "../presentation/Header";
import { Footer } from '../presentation/Footer';
import { LoginPage } from '../presentation/LoginPage';

export const Login = () => {
  return (
    <>
      <Header />
      <LoginPage />
      <Footer />
    </>
  )
}
